import Button, { EButtonVariant } from "@Front/Components/DesignSystem/Button";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import classes from "@Front/Components/Layouts/Login/classes.module.scss";
import { UserIcon, BuildingOffice2Icon } from "@heroicons/react/24/outline";

type Props = {
	onChooseCustomer: () => void;
	onChooseThirdParty: () => void;
	isSubmitting: boolean;
};

export default function StepActorChoice(props: Props): React.JSX.Element {
	const { onChooseCustomer, onChooseThirdParty, isSubmitting } = props;
	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY} className={classes["disambiguation-hint"]}>
				Cet email correspond à un accès client et à un accès tiers pour au moins une étude. Choisissez l’espace à utiliser.
			</Typography>
			<div className={classes["disambiguation-stack"]}>
				<Button type="button" onClick={onChooseCustomer} isLoading={isSubmitting} fullwidth leftIcon={<UserIcon width={20} height={20} />}>
					Espace client
				</Button>
				<Button
					type="button"
					variant={EButtonVariant.SECONDARY}
					onClick={onChooseThirdParty}
					isLoading={isSubmitting}
					fullwidth
					leftIcon={<BuildingOffice2Icon width={20} height={20} />}
				>
					Espace tiers
				</Button>
			</div>
		</div>
	);
}
